// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","809":"transfer"}[chunkId] + "-legacy." + {"443":"3b4a212e","809":"5016ff70"}[chunkId] + ".js";
};